import { render } from "./MentionTooltip.vue?vue&type=template&id=c0edaacc"
import script from "./MentionTooltip.vue?vue&type=script&lang=js"
export * from "./MentionTooltip.vue?vue&type=script&lang=js"

import "./MentionTooltip.vue?vue&type=style&index=0&id=c0edaacc&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__